export const isActiveTask = (task) =>
  task.status === 'pending' || task.status === 'running'

export const isRecentTask = (task, minutes = 5) => {
  const threshold = new Date(Date.now() - minutes * 60 * 1000)
  return new Date(task.createdAt) > threshold
}
